import { useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { CloseIcon } from "../../../../data/iconImage";
import { formatDate } from "../../../../commons/FormatValue";
import { formatInputDate, monthsDifference } from "../../../../utils/Time";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { FormCheckComponent } from "../../../../components/FormComponent";
import {
  filteredItemInArray,
  findItemInArray,
  flattenedArray
} from "../../../../utils/ManageArray";
import Table from "../../../../components/Table";
import SearchFilter from "../../../../components/SearchFilter";
import CustContractsService from "../../../../services/custcontract.service";
import CustContractItemsService from "../../../../services/custcontractitem.service";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function ContractTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const [contract, setContract] = useState([]);
  const [contractItem, setContractItem] = useState([]);
  const defaultFilter = {
    All: true,
    Current: false,
    Expiring: false,
    Expired: false
  };
  const [filter, setFilter] = useState(defaultFilter);
  const [month, setMonth] = useState(0);
  const currentDate = new Date();
  const nextDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
  const defaultSearch = [
    {
      name: "Contract_Start_Date",
      label: "วันที่เริ่มสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      queryService: (query) => getCustContracts(query)
    },
    {
      name: "Contract_End_Date",
      label: "วันที่สิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      queryService: (query) => getCustContracts(query)
    },
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      queryService: (query) => {
        const [start, end] = searchValue.filter(
          ({ name, type }) =>
            type === "date" &&
            ["START", "END"].some((suffix) =>
              name.toUpperCase().includes(suffix.toUpperCase())
            )
        );

        const searchStart = start?.value ? `&start=${start?.value}` : "";
        const searchEnd = end?.value ? `&end=${end?.value}` : "";
        getCustContracts(query + searchStart + searchEnd);
      }
    },
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      queryService: (query) => {
        const [start, end] = searchValue.filter(
          ({ name, type }) =>
            type === "date" &&
            ["START", "END"].some((suffix) =>
              name.toUpperCase().includes(suffix.toUpperCase())
            )
        );

        const searchStart = start?.value ? `&start=${start?.value}` : "";
        const searchEnd = end?.value ? `&end=${end?.value}` : "";
        getCustContracts(query + searchStart + searchEnd);
      }
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      disabled: true,
      type: "text",
      size: 9,
      findValue: { value: "Customer.Cus_Code" }
    }
  ];
  const [searchInput, setSearchInput] = useState(defaultSearch);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "เลขที่โครงการ",
      selector: (row) => row.Project_No,
      sortable: true,
      minWidth: "200px"
    },
    {
      name: "เลขที่สัญญา",
      selector: (row) => row.Contract_No,
      minWidth: "200px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row.Customer?.Cus_Code,
      minWidth: "200px"
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row.Customer?.Cus_Name,
      minWidth: "300px"
    },
    {
      name: "วันที่เริ่มสัญญา",
      selector: (row) => row.Contract_Start_Date,
      format: (row) => formatDate(row.Contract_Start_Date),
      minWidth: "200px"
    },
    {
      name: "วันที่สิ้นสุดสัญญา",
      selector: (row) => row.Contract_End_Date,
      format: (row) => formatDate(row.Contract_End_Date),
      minWidth: "200px"
    },
    {
      name: "จำนวน PM/ปี",
      selector: (row) => row.CustContractItem?.PM_Per_Year,
      minWidth: "150px"
    },
    {
      name: "เปลี่ยนจำนวน PM/ปี",
      selector: (row) => row.CustContractItem?.Change_Pm_Per_Year,
      minWidth: "150px"
    },
    {
      name: "สาเหตุที่เปลี่ยนจำนวน PM/ปี",
      selector: (row) => row.CustContractItem?.Reason_Change_Pm_Per_Year,
      minWidth: "200px"
    },
    {
      name: "ประเภทบริการ",
      selector: (row) => row.CustContractItem?.DownTime?.DT_Name,
      minWidth: "200px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row.CustContractItem?.Item?.Item_Code,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.CustContractItem?.Item?.Item_Name_TH,
      minWidth: "300px"
    }
  ];

  const formCheck = ({ field }) => {
    return (
      <>
        <Form.Label className="me-1 mb-0">ตัวกรอง :</Form.Label>
        {field.map(({ name, label }, idx) => (
          <FormCheckComponent
            key={idx}
            id={name}
            type="radio"
            name="filter"
            label={label}
            image={
              name !== "All" ? <Image src={CloseIcon} alt="Close Icon" /> : null
            }
            className={{
              check: "h-100 m-0 ps-3 pe-1",
              input: "m-0 d-none",
              label:
                "h-100 px-3 py-1 d-flex align-items-center border border-secondary rounded-pill"
            }}
            onChange={() =>
              handleChangeFilter(name, name === "All" ? searchValue : [])
            }
            checked={!!filter[name]}
          />
        ))}

        {filter.Expired && (
          <Form.Group
            className="ms-3 px-3 d-flex align-items-center position-relative border rounded-pill"
            style={{ minWidth: "120px", width: "120px", height: "34px" }}
          >
            <Form.Control
              min="0"
              type="number"
              readOnly={!filter.Expired}
              className="ms-3 p-0 bg-transparent border-0"
              onChange={({ target }) => setMonth(target.value)}
              value={month}
            />
            <Form.Label className="mb-0 position-absolute end-30">
              เดือน
            </Form.Label>
          </Form.Group>
        )}
      </>
    );
  };

  const getCustContracts = (keyword) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractsService.getAllCustContracts(keyword),
      callback: ({ items }) => setContract(items)
    });
  };

  const getCustContractItems = (keyword) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractItemsService.getAllCustContractItems(keyword),
      callback: ({ items }) => setContractItem(items)
    });
  };

  const handleChangeFilter = (name, search) => {
    setFilter({
      All: name === "All",
      Current: name === "Current",
      Expiring: name === "Expiring",
      Expired: name === "Expired"
    });
    if (name !== "Expired") setMonth(0);
    if (name === "All") {
      setSearchInput(defaultSearch);
      return setSearchValue(search);
    }

    let [start, end] = [null, null];

    if (name === "Expiring") end = formatInputDate(nextDate, "ISO").date;
    if (name === "Current") {
      start = `${new Date().getFullYear()}-01-01`;
      end = `${new Date().getFullYear()}-12-31`;
    }
    if (name === "Expired") {
      const monthDiff = monthsDifference(currentDate, -month);
      start = formatInputDate(monthDiff, "ISO").date;
      end = formatInputDate(nextDate, "ISO").date;
    }

    if (start || end) {
      const updatedItems = searchInput.map((item) => {
        if (item.name === "Contract_Start_Date") {
          return { ...item, disabled: name !== "All", value: start };
        }
        if (item.name === "Contract_End_Date") {
          return { ...item, disabled: name !== "All", value: end };
        }
        return item;
      });
      setSearchInput(updatedItems);

      const updatedSearchs = search.map((item) => {
        if (item.name === "Contract_Start_Date")
          return { ...item, value: start };
        if (item.name === "Contract_End_Date") return { ...item, value: end };
        return item;
      });

      setSearchValue(updatedSearchs);
    }
  };

  const handleSearchFilter = (search) => {
    if (search?.length) {
      const keyword =
        findItemInArray(search, "name", "Contract_No")?.value ??
        findItemInArray(search, "name", "Customer.Cus_Code")?.value ??
        null;
      const [start, end] = search.filter(
        ({ name, type }) =>
          type === "date" &&
          ["START", "END"].some((suffix) =>
            name.toUpperCase().includes(suffix.toUpperCase())
          )
      );

      const searchKey = keyword ? `&keyword=${keyword}` : "";
      const searchStart = start?.value ? `&start=${start?.value}` : "";
      const searchEnd = end?.value ? `&end=${end?.value}` : "";
      getCustContracts(`?limit=1000${searchKey}${searchStart}${searchEnd}`);
      getCustContractItems(`?limit=1000${searchKey}${searchStart}${searchEnd}`);

      if (filter.All) handleChangeFilter("All", search);
      if (filter.Current) handleChangeFilter("Current", search);
      if (filter.Expired) handleChangeFilter("Expired", search);
      if (filter.Expiring) handleChangeFilter("Expiring", search);
    } else handleChangeFilter("All", search);
  };

  useEffect(() => {
    if (contract?.length) {
      const filteredAddContract = contract.map(
        ({ Contract_No, ...contract }) => ({
          ...contract,
          Contract_No,
          CustContractItem: filteredItemInArray(
            contractItem,
            "Contract_No",
            Contract_No
          )
        })
      );
      setData(flattenedArray(filteredAddContract, "CustContractItem"));
    }
  }, [contract, contractItem]);

  useEffect(() => {
    if (month !== 0) handleChangeFilter("Expired", searchValue);
  }, [month]);

  return (
    <>
      <CardDisplayComponent
        body={{
          element: (
            <SearchFilter
              data={contract}
              inputField={searchInput}
              clearBtnOnClick={filter.All}
              fieldClassName={{
                inputRow: "justify-content-start align-items-center",
                actionButton: "mb-1 pb-3 pb-sm-0 text-start"
              }}
              searchCallback={handleSearchFilter}
            />
          )
        }}
        footer={{
          className: "filter d-flex align-items-center",
          element: (
            <>
              {formCheck({
                field: [
                  { name: "All", label: "ทั้งหมด" },
                  { name: "Current", label: "สัญญาปัจจุบัน" },
                  { name: "Expiring", label: "หมดสัญญา" },
                  { name: "Expired", label: "ใกล้หมดสัญญา" }
                ]
              })}
            </>
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "สัญญางานบริการ MA" } }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              pending={loading}
              searchFilter={searchValue}
              pagination
            />
          )
        }}
      />
    </>
  );
}
